<template>
  <div :class="$style.toolbar">
    <div :class="$style.toolbar__left">
      <div
        v-if="uiConfig.ui.includes('yearSwitch')"
        :class="$style.chart_toolbox"
      >
        <div :class="$style.year_switch">
          <vgp-icon-button
            :icon="{ name:'arrow-left', type: 'bold' }"
            size="small"
            :disabled="toolbarYearSwitchData.minYear === toolbarYearSwitchData.currentYear"
            @onClick="setCurrent(-1)"
          />

          <div :class="$style.current">
            {{ toolbarYearSwitchData.currentYear }} {{ locales('year') }}
          </div>

          <vgp-icon-button
            :icon="{ name:'arrow-right', type: 'bold' }"
            size="small"
            :disabled="toolbarYearSwitchData.maxYear === toolbarYearSwitchData.currentYear"
            @onClick="setCurrent(1)"
          />
        </div>
      </div>
      <div
        v-if="uiConfig.ui.includes('range') && rangeValue.length"
        :class="[$style.range_value, $style.right_divider]"
      >
        {{ rangeValue }}
      </div>
      <toolbar-dropdown
        v-if="uiConfig.ui.includes('dropdown')"
        :menu="dropMenu"
        :disabled="toolbarDisabled"
        @onSelect="data => $emit('onSelectDropdown', data)"
      />
    </div>
    <div :class="$style.toolbar__right">
      <filter-button
        v-if="uiConfig.ui.includes('filter')"
        :delimiter-left="false"
        :delimiter-right="hasAccessToExport"
      />
      <tooltip
        v-if="uiConfig.ui.includes('export') && hasAccessToExport"
        :class="$style.tooltip_wrapper"
        :content="tooltipContent"
        :position="'bottom-end'"
        :interactive="true"
        :with-animation="false"
      >
        <template #body>
          <vgp-icon-button
            size="small"
            :colors="buttonColors"
            :disabled="toolbarDisabled"
            :label="locales('common_export')"
            :icon="{ name:'link-2', size: 20 }"
            @onClick="onClickExport"
          />
        </template>
      </tooltip>
    </div>
  </div>
</template>

<script>
import vgpIconButton from '$$vueCmp/globalButton/withIcon/iconButton.vue';
import toolBarUiConfig from './toolBarUiConfig';
import filterButton from '../../filter/components/filterButton.vue';
import toolbarDropdown from './toolbarDropdown.vue';
import Export from './export';
import tooltip from '../../common/VueComponents/tooltips/tooltip.vue';
import rights from '../../../components/rights/index';

export default {
  components: {
    vgpIconButton,
    filterButton,
    toolbarDropdown,
    tooltip,
  },
  props: {
    iconName: {
      type: String,
      required: false,
      default: 'report',
    },
    iconColor: {
      type: String,
      required: false,
      default: '#00564C',
    },
    dropMenu: { type: Array, default: () => [] },
    rangeValue: { type: String, required: false, default: '' },
    toolbarDisabled: { type: Boolean, required: false, default: false },
    toolbarYearSwitchData: {
      type: Object,
      required: false,
      default: () => ({
        currentYear: new Date().getFullYear(),
        minYear: new Date().getFullYear(),
        maxYear: new Date().getFullYear(),
      }),
    },
    reportTitle: { type: String, required: true, default: '' },
  },
  emits: {
    setYear: Number,
    onSelectDropdown: Object,
    onExportPortfolioReport: null,
  },
  data() {
    return {
      locales: __,
      uiConfig: { ui: [] },
      buttonColors: {
        color: '#333333',
        labelColor: '#191919',
        activeColor: '#11519A',
        hoverBg: '#F2F2F2',
        activeBg: '#D0E0F2',
        activeHoverBg: '#A1C1E6',
      },
    };
  },
  computed: {
    mode() {
      if (this.$route?.params?.type === 'portfolio') {
        return 'table';
      }

      return 'graphic';
    },
    tooltipContent() {
      return this.mode === 'table' ? __('header_toolbar_export_tooltip_report_table') : __('header_toolbar_export_tooltip_graphic');
    },
    hasAccessToExport() {
      return rights.account.hasRight('export');
    },
  },
  mounted() {
    const path = this.$route.path.split('/').slice(1).join('_'); // view like name_of_router

    this.uiConfig = toolBarUiConfig.getConfig(path);
  },

  methods: {
    setCurrent(delta) {
      const result = this.toolbarYearSwitchData.currentYear + delta;

      this.$emit('setYear', result);
    },
    onClickExport() {
      const reportType = this.$route?.params?.type || null;
      const reportNameAnalytics = this.reportTitle.replace(/^exmp_chart_/, '').replace(/_title$/, '');
      let toolbarYear = null;

      if (reportType === 'portfolio') {
        this.$emit('onExportPortfolioReport');
        userExtAnalytics.log('report_creation_modal_open', {
          export_format: 'XLSX',
          report_type: reportNameAnalytics,
        });

        return;
      }

      if (reportType === 'milestone') {
        toolbarYear = this.toolbarYearSwitchData.currentYear;
      }

      const reportName = __(`${this.reportTitle}`);
      const reportHtml = document.documentElement.querySelector('#report_export_id')
        || document.documentElement.querySelector('.report_export_id');

      if (reportHtml) {
        userExtAnalytics.log('report_creation_modal_open', {
          export_format: 'PDF',
          report_type: reportNameAnalytics,
        });

        Export.exportToPdf(reportHtml, reportName, {
          rangeString: this.rangeValue,
          yearSwitchString: toolbarYear,
        });
      }
    },
  },
};
</script>

<style module src='./../less/reportsMain.less'></style>
